// extracted by mini-css-extract-plugin
export default {"menuBlock":"yJ-z","title":"zJ-z","nav":"AJ-z","flexCell":"BJ-z","facetLink":"CJ-z"};